'use client';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';

const additionalServices = [
{
  id: 'insurance',
  icon: 'ShieldCheckIcon',
  title: 'Cargo Insurance',
  description: 'Comprehensive coverage for your shipments against loss, damage, or theft',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_153fcbd89-1767798860725.png",
  alt: 'Insurance documents and protection shield representing cargo insurance coverage',
  benefits: ['Full Value Coverage', 'Claims Support', 'Global Protection', 'Instant Quotes']
},
{
  id: 'packaging',
  icon: 'CubeIcon',
  title: 'Professional Packaging',
  description: 'Expert packing services to ensure your goods arrive safely at destination',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b7a1c8ec-1766590780134.png",
  alt: 'Professional packaging materials and boxes for secure shipping',
  benefits: ['Custom Crating', 'Fragile Handling', 'Palletizing', 'Shrink Wrapping']
},
{
  id: 'consulting',
  icon: 'ChatBubbleLeftRightIcon',
  title: 'Logistics Consulting',
  description: 'Strategic guidance to optimize your supply chain and reduce shipping costs',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17b3eb71a-1770422413952.png",
  alt: 'Business team consulting on logistics strategy and supply chain optimization',
  benefits: ['Route Optimization', 'Cost Analysis', 'Process Improvement', 'Compliance Advice']
}];


export default function ServicesShowcase() {
  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
            Additional Services
          </h2>
          <p className="text-lg text-muted-foreground">
            Comprehensive support services to complement your shipping needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {additionalServices.map((service) =>
          <div
            key={service.id}
            className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105">
            
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden">
                <AppImage
                src={service.image}
                alt={service.alt}
                className="w-full h-full object-cover" />
              
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                    <Icon name={service.icon as any} size={24} className="text-primary" />
                  </div>
                </div>
              </div>

              {/* Service Details */}
              <div className="p-6">
                <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {service.description}
                </p>

                {/* Benefits */}
                <ul className="space-y-2 mb-4">
                  {service.benefits.map((benefit, index) =>
                <li key={index} className="flex items-center gap-2 text-sm text-foreground">
                      <Icon name="CheckIcon" size={16} className="text-success" />
                      <span>{benefit}</span>
                    </li>
                )}
                </ul>

                {/* CTA */}
                <Link
                href="/contact"
                className="inline-flex items-center gap-2 text-primary font-medium hover:gap-3 transition-all">
                
                  <span>Learn More</span>
                  <Icon name="ArrowRightIcon" size={16} />
                </Link>
              </div>
            </div>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <Link
            href="/order"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-all hover:scale-105">
            
            <Icon name="public/assets/images/ChatGPT_Image_Feb_7_2026_02_48_47_AM-1770428942096.png" size={20} />
            <span>Start Your Shipment</span>
            <Icon name="ArrowRightIcon" size={20} />
          </Link>
        </div>
      </div>
    </section>);

}